class Match {
    
    /**
     * Metodo di debounce, usato per addEventListener
     * @param {type} func
     * @param {type} delay
     * @returns {Function}
     */
    debounce(func, delay) {
        let inDebounce
        
        return function() {
            const context = this
            const args = arguments
            clearTimeout(inDebounce)
            inDebounce = setTimeout(() => func.apply(context, args), delay)
        }
    }

    /**
     * Setta l'altezza identica all'elemento più grande per tutti gli elementi passati
     * @param {type} $els
     * @returns {Match}
     */
    height($els) {
        
        var that = this;
        
        // window resize
        window.addEventListener('resize', this.debounce(function() {
          that.height($els)
        }, 500));
        
        // Find out how my divs there are with the class 'match-height' 
        var arrayLength = $els.length;
        var heights = [];

        //Create a loop that iterates through the getDivs variable and pushes the heights of the divs into an empty array
        for (var i = 0; i < arrayLength; i++) {
            heights.push($els[i].offsetHeight);
        }

         //Find the largest of the divs
        function getHighest() {
          return Math.max(...heights);
        }

        //Set a variable equal to the tallest div
        var tallest = getHighest();

        //Iterate through getDivs and set all their height style equal to the tallest variable
        for (var i = 0; i < $els.length; i++) {
            $els[i].style.minHeight = tallest + "px";
            // console.log($els[i]);
            // $els[i].style.height = tallest + "px";
        }
        
        return this;
    }

}

// export
export default new Match();